'use client';
import { cn } from '@noirproperties/ui/lib/utils';
import { useVideoActions, useVideoState } from './video-hooks';

type VideoBackButtonProps = {
  children: React.ReactNode;
  className?: string;
};

export function VideoBackButton({ children, className }: VideoBackButtonProps) {
  const { mute } = useVideoActions();
  const { isPlaying } = useVideoState();
  return (
    <button
      className={cn(
        'absolute bottom-8 start-4',
        'sm:bottom-20 sm:start-20',
        'text-sm font-semibold leading-6 text-gray-100',
        'rounded-md bg-black/20 px-3 py-1.5 backdrop-blur-sm',
        'transition-colors hover:bg-black/30',
        isPlaying && 'z-20',
        className,
      )}
      onClick={mute}
      type="button"
    >
      {children}
    </button>
  );
}
